// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HZYN","controls":"styles_controls__2PnPD","charLimit":"styles_charLimit__3Wc__","input":"styles_input__wG1nG","send":"styles_send__2UeFm"};